<nz-form-item class="label-on-top">
  <nz-form-label [nzRequired]="isRequired(control)">
    {{ label }}
  </nz-form-label>
  <nz-form-control nzHasFeedback [nzErrorTip]="errorTemplate" [nzValidateStatus]="control">
    @if (showCopy) {
      <div class="copy-group">
        <ng-container *ngTemplateOutlet="textAreaTemplate"></ng-container>
        <span
          class="ant-input-group-addon copy-addon"
          [class.copy-addon-empty]="!copyText()"
          title="Copy"
          (click)="copyValue()"
        >
          <i nz-icon [nzType]="copied ? 'check' : 'copy'"></i>
        </span>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="textAreaTemplate"></ng-container>
    }
    <i
      *ngIf="showClear && control?.value"
      nz-icon
      nzType="close-circle"
      nzTheme="fill"
      (click)="clearInput()"
    ></i>
  </nz-form-control>
  <ng-template #errorTemplate>
    {{ control.errors | formError }}
  </ng-template>
</nz-form-item>

<ng-template #textAreaTemplate>
  <textarea nz-input class="mt-2" [placeholder]="placeholder" [formControl]="control"></textarea>
</ng-template>
